import type { Role } from '@altyor-kronos/shared-types';

/**
 * Clockify's "Group" column held values like "R&D Méca". The Hub has no direct
 * equivalent, so we derive it from the user's R&D roles. Order matters: the
 * first matching role in this table wins when a user holds several.
 */
const ROLE_TO_GROUP: { role: Role; group: string }[] = [
  { role: 'rd_meca', group: 'R&D Méca' },
  { role: 'rd_elec', group: 'R&D Élec' },
  { role: 'rd_test_bench', group: 'R&D Banc de test' },
  { role: 'rd_manager', group: 'R&D Management' },
  { role: 'dft', group: 'DFT' },
];

export function groupFromRoles(roles: Role[]): string {
  for (const { role, group } of ROLE_TO_GROUP) {
    if (roles.includes(role)) return group;
  }
  return '';
}
